<!--
* @description  返回结果
* @fileName  noResults
* @author userName
* @date 2024-04-11 16:45:00
!-->
<template>
	<div id="noResults" class="flex flex-column flex-column-center">
		<div class="noResults" v-if="CheckPriceList.length <= 0">
			<img src="@/assets/img/client/check/noList.png" width="234px" height="209px" />
			<p>{{ $t('home.checkNoList') }}</p>
		</div>
		<div class="check-history margin-top_36" v-if="CheckPriceList.length > 0">
			<div class="flex flex-column-center check-history-header">
				<div class="title">{{ $t('home.checkHistory') }}</div>
				<div class="clear margin-left_16" @click="removeLog('')">{{ $t('home.checkEmpty') }}</div>
			</div>
			<div class="flex flex-wrap-wrap margin-left__16 margin-top__16">
				<div class="check-history-item flex flex-column-center" v-for="(item, index) in CheckPriceList"
					:key="index" @click.stop="CheckPrice(item)">
					<div class="text1">
						{{ `${item.OriginCountryCode},${item.OriginAddressCode}` }}
					</div>
					<div class="text2 margin-left_8 margin-right_8">-</div>
					<div class="text1">
			{{
              `${item.DestinationCountryCode},${item.DestinationAddressCode}`
            }}
					</div>
					<div class="text2 margin-left_16">
			{{
              `${item.TotalQuantity} ${$t('common.piece')}，${item.TotalVolume} CBM，${item.TotalWeight} KG`
            }}
					</div>
					<div class="margin-left_16 margin-right_8 delete-icon" @click.stop.prevent="removeLog(item.id)">
						<i class="el-icon-error"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { GetLogList, ToppingLog, RemoveLog } from '@/api/checkPrice'
	export default {
		props: {
      calculationSource: { type: Number, default: 0 }
		},
		name: 'noResults',
		data() {
			return {
				CheckPriceList: [],
			};
		},
		created() {
			// 实例被创建之后执行代码
		},
		computed: {
			// 计算属性
		},
		components: {
			// 组件的引用
		},
		methods: {
			// 方法
			getQueryLog() {
        console.log(this.calculationSource)
				GetLogList(this.calculationSource).then((res) => {
					if (res.code === 200) {
						if (res.data && res.data.length > 0) {
							this.IsShow = true;
							this.CheckPriceList = res.data;
						} else {
							this.IsShow = false;
							this.CheckPriceList = [];
						}
						this.$forceUpdate();
					}
				});
			},
			removeLog(id) {
				RemoveLog(id).then((res) => {
					if (res.code === 200) {
						this.getQueryLog();
					}
				});
			},
			topping(item) {
				item.IsTop = item.IsTop === 0 ? 1 : 0;
				ToppingLog({
					id: item.id,
					status: item.IsTop,
				}).then((res) => {
					if (res.code === 200) {
						this.getQueryLog();
					}
				});
			},
			CheckPrice(item) {
				this.$eventBus.$emit('checkPrice', item);
			},
		},
		mounted() {
			// 页面进入时加载内容
			this.getQueryLog();
		},
		watch: {
			// 监测变化
		},
	};
</script>
<style scoped lang="scss">
	.noResults {
		margin-top: 154px;

		p:nth-of-type(1) {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 16px;
			color: #777777;
			line-height: 22px;
			text-align: center;
			font-style: normal;
		}

		p:nth-of-type(2) {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 16px;
			color: #777777;
			line-height: 22px;
			text-align: center;
			font-style: normal;
		}
	}

	.check-history {
		width: 1200px;
		box-sizing: border-box;

		.check-history-header {
			height: 40px;

			.title {
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				font-size: 13px;
				color: #333333;
				line-height: 18px;
				text-align: left;
				font-style: normal;
			}

			.clear {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #3370ff;
				line-height: 17px;
				text-align: left;
				font-style: normal;

				&:hover {
					cursor: pointer;
				}
			}
		}

		.check-history-item {
			margin: 16px 0 0 16px;
			padding: 8px;
			background: rgba(0, 0, 0, 0.04);
			border-radius: 8px;
			transition: all 0.3s;
			box-sizing: border-box;

			.text1 {
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				font-size: 12px;
				color: #333333;
				line-height: 17px;
				text-align: left;
				font-style: normal;
			}

			.text2 {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #777777;
				line-height: 17px;
				text-align: left;
				font-style: normal;
			}

			.delete-icon {
				visibility: hidden;
				opacity: 0;
				transition: all 0.3s;

				i {
					font-size: 16px;
					color: #aaaaaa;
					cursor: pointer;
				}
			}

			&:hover {
				cursor: pointer;

				background: rgba(51, 112, 255, 0.08);

				.delete-icon {
					visibility: visible;
					opacity: 1;
				}
			}
		}
	}
</style>